import { CircularProgress } from '@mui/material'

const Loader = ({ size = 18, color = 'black' }) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', color: color }}>
      <CircularProgress color="inherit" size={size} />
    </div>
  )
}

export default Loader
